import {
  Component, OnDestroy, OnInit, OnChanges, SimpleChanges,
  ElementRef, ViewChild, AfterViewInit, NgZone, Optional, Input, Output,
  EventEmitter
} from '@angular/core';
import { Observable, combineLatest, of, Subscription, from } from 'rxjs';
import { catchError, map, mergeMap } from "rxjs/operators";
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from "@angular/forms";
import {
  DwConfigServiceToken, DwConfigService, DwSecurityUserService, DwComponent, DwComponentType, DwMetaDataService,
  DwSectionBaseComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfig,
  DwMetaDataFormApi, DwActionPreference, DwFormActionConfig, DwFormActionKeys, DwEventService,
  DwFormActionInterceptResult, DwFormValidationResult, DwSelectComponent,
  DwUIMetaDataConfigToken, DwMetaDataServiceToken, DwFormActionInterceptor
}
  from '@devwareapps/devware-cap';
import { DwMetaDataFormStateService } from '@devwareapps/devware-cap';
import { AviatorUser } from '../../../shared/models/aviator-user.model';
import { Inject, Injectable } from "@angular/core";
import { AppMetaDataItemNames, ProcessorConfigEntity, PaymentMethodEntity, UserTypeAllItems }
  from '../../../../meta-data/app-meta-data.service';
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { HttpClient } from "@angular/common/http";
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { environment } from 'src/environments/environment';
import { EnvironmentConfigItem } from 'src/environments/models/environment-config.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { AdminManagerService } from 'src/app/features/admin/services/admin-manager.service';
import { BillingDetailsContext } from '../../models/billings-details.model';
import { PricingDiscountResult } from '../../models/pricing-discount-result.model';
import { DiscountView, DiscountCodeComponent } from '../discount-code/discount-code.component';
import { AviatorOnlineUserTypeIds } from 'src/app/features/shared/models/aviator-user-type.enum';
import { PurchaseCourseModalConfig } from "../../models/purchase-course-modal-config.model";
import { PaymentParty } from '../../models/payment-party.enum';
import { StripeDiagnosticsService } from '../../services/stripe-diagnostics.service';

@DwComponent({
  key: 'student-purchase-course',
  name: 'Student Course Purchase',
  componentType: DwComponentType.formSection,
  isGlobal: true,
})
@Component({
  selector: 'app-student-purchase-course',
  templateUrl: './student-purchase-course.component.html',
  styleUrls: ['./student-purchase-course.component.scss']
})
export class StudentPurchaseCourseComponent extends DwSectionBaseComponent
  implements OnInit, OnDestroy {

    

  constructor(
    private ngZone: NgZone,
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwSecurityUserService: DwSecurityUserService,
    private paymentsRepoSvc: PaymentsRepositoryService,
    private dwEventService: DwEventService,
    private dateTimeUtilService: DateTimeUtilService,
    private adminManagerService: AdminManagerService,
    private http: HttpClient,
    private stripeDiagnosticsService: StripeDiagnosticsService,
    @Inject(DwConfigServiceToken) private configService: DwConfigService) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    StudentPurchaseCourseComponent.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
  }

  subscriptions: Subscription[] = [];
  aviatorUser: AviatorUser;
  static paymentsApi: string;
  formApi: DwMetaDataFormApi;
  stripe: any;
  clientSecret: string = undefined;
  test: boolean = false;
  payment: any;
  elements: any;
  nameOnCard: string = undefined;
  billingEmail: string = undefined;
  billingZip: string;
  nickname: string = 'Default';
  makeDefault: boolean = true;
  alreadyDefault: boolean;
  processorConfig: ProcessorConfigEntity = undefined;
  customerId: string;
  loading: boolean = true;
  stripeErrorMessage: string = undefined;
  methods: PaymentMethodEntity[] = [];
  hasChanges: boolean = false;
  dupes: number[] = [];
  paymentType: string = 'default';
  payWith: number;

  @Input() discountCode: string;
  @Input() modalData: PurchaseCourseModalConfig;
  @Output() discountCodeChange = new EventEmitter<string>();
  @Output() discountCodeApplied = new EventEmitter<string>();
  @Output() discountCodeCleared = new EventEmitter<void>();
  @Output() paymentMethodChange = new EventEmitter<PaymentMethodEntity>();
  @Input() discountResult: PricingDiscountResult;
  @Input() purchasing: boolean = false;

  setupComponentComplete() {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.test = this.isTest();
    this.stripe = (globalThis as any).stripe;
    this.aviatorUser = this.adminManagerService.getAviatorUser();
    this.billingEmail = this.aviatorUser.user.Email;
    this.nameOnCard = `${this.aviatorUser.user.FirstName} ${this.aviatorUser.user.LastName}`;
    this.updateMethods();
  }

  changeType() {
    if (this.modalData.type != 'add' && this.paymentType == 'add' && this.payment == undefined) {
      this.setupPaymentElement();
    }
    this.modalData.type = this.paymentType;
  }
  getDefaultPayment(): PaymentMethodEntity {
    return this.methods.find(p => p.IsDefault);
  }

  onDiscountCodeChange(e: string) {
  }
  onDiscountCodeApplied(e: string) {
    this.discountCode = e;
    this.discountCodeApplied.emit(e);
  }
  onDiscountCodeCleared() {
    this.discountCodeCleared.emit();
  }

  updateMethods() {
    const obs = this.processorConfig == undefined
      ? this.paymentsRepoSvc.getProcessorConfig(PaymentParty.Student).pipe(map(r => r.ProcessorConfig))
      : of(this.processorConfig);

    obs.subscribe(cfg => {
      this.processorConfig = cfg;
      this.customerId = cfg.CustomerId;
      if (cfg != undefined)
        this.paymentsRepoSvc.getPaymentMethodsForConfig(cfg)
          .subscribe(pms => {
            this.methods = pms;
            this.modalData.methods = this.methods;
            const defaultMethod = this.getDefaultPayment();
            this.modalData.payment = defaultMethod
              ?? (this.methods.length > 0 ? this.methods[0] : undefined);
            this.payWith = this.modalData.payment?.PaymentMethodId;
            this.modalData.paymentMethodId = this.payWith;

            this.paymentMethodChange.emit(this.modalData.payment);

            // Default to add if no payment methods exists
            // TODO: When this is added, the payment element isn't displayed
            if (this.methods.length == 0) {
              this.paymentType = 'add';
              this.changeType();
            }
          });
    });
  }

  payWithCard(id: number) {
    this.modalData.paymentMethodId = this.payWith;
    this.modalData.payment = this.methods.find(p => p.PaymentMethodId == id);

    this.paymentMethodChange.emit(this.modalData.payment);
  }

  createPaymentIntent(): Observable<CreatePaymentIntent> {
    let url = StudentPurchaseCourseComponent.paymentsApi;
    url = `${url}/setup-future-payment/${AviatorOnlineUserTypeIds.student}`;
    return this.http.get<CreatePaymentIntent>(url);
  }

  setupPaymentElement() {
    if (this.payment == undefined)
      this.createPaymentIntent()
        .subscribe({
          next: async r => {
            try {
              this.clientSecret = r.ClientSecret;
              await this.setUpPaymentElement();
            } catch (error) {
              this.handleStripeError('Stripe payment element initialization failed for student purchase', error);
            }
          },
          error: error => this.handleStripeError('Stripe setup intent creation failed for student purchase', error)
        });
  }
  async setUpPaymentElement() {
    if (!this.stripe?.core || typeof this.stripe.core.elements != 'function') {
      this.handleStripeError('Stripe.js was unavailable during student purchase payment element setup', new Error('Stripe.js not loaded'));
      return;
    }

    const clientSecret = this.clientSecret;
    const appearance = { theme: 'stripe' };
    const defaultValues = {
      billingDetails: {
        name: this.nameOnCard,
        email: this.billingEmail
      }
    };
    const fields = {
      billingDetails: {
        name: 'auto',
        email: 'auto',
        phone: 'auto',
        address: 'if_required'
      }
    };
    const options = {
      layout: 'tabs',
      appearance,
      defaultValues,
      fields
    };
    try {
      this.elements = this.stripe.core.elements({ clientSecret });
      this.elements.fetchUpdates()
        ?.catch(error => this.handleStripeError('Stripe payment element fetchUpdates failed for student purchase', error));

      this.payment = this.elements.create('payment', options);
      this.payment.mount('#payment-element');
      const wrapper = (e) => this.ngZone.run(() => this.paymentOnChange(e));
      this.payment.on('change', wrapper);
      this.loading = false;
      this.stripeErrorMessage = undefined;
    } catch (error) {
      this.handleStripeError('Stripe payment element mount failed for student purchase', error);
      return;
    }

    this.modalData.elements = this.elements;
    this.modalData.stripe = this.stripe.core;
    const pm: PaymentMethodEntity = {
      _itemName: AppMetaDataItemNames.PaymentMethod,
      ProcessorConfigId: this.processorConfig?.ProcessorConfigId,
      ClientSecret: clientSecret
    }
    this.modalData.payment = pm;
  }
  paymentOnChange(event: any = null, input: string = null, ctrl: any = null) {
    //console.log('payment change', event, input, ctrl);

    this.modalData.payment.BillingEmail = this.billingEmail;
    this.modalData.payment.BillingName = this.nameOnCard;
    this.modalData.payment.DisplayName = this.nickname;
    this.modalData.payment.BillingPostalCode = this.billingZip;

    this.paymentMethodChange.emit(this.modalData.payment);
  }

  static makePaymentDefault(makeDefault: boolean, pm: PaymentMethodEntity, paymentsRepoSvc: PaymentsRepositoryService, http: HttpClient): Observable<NewCardCheckResult> {
    let url = StudentPurchaseCourseComponent.paymentsApi;
    url = `${url}/update-payment-method/${pm.PaymentId}/${AviatorOnlineUserTypeIds.student}`;
    pm.IsDefault = makeDefault;
    return paymentsRepoSvc
      .savePayment(pm)
      .pipe(mergeMap(pm => {
        return http.get(url)
          .pipe(map(resp => {
            return {
              error: (resp as any).ErrorMessage, PaymentMethod: (resp as any).Pm
            };
          }));
      }));
  }

  static checkForNewCard(type: string, data: AddNewCard, elements: any, stripe: any,
    paymentsRepoSvc: PaymentsRepositoryService, http: HttpClient, stripeDiagnosticsService: StripeDiagnosticsService)
    : Observable<NewCardCheckResult> {

    if (type == 'default') {
      const pm = data.PaymentMethod;
      return pm.IsDefault
        ? of({ PaymentMethod: pm })
        : this.makePaymentDefault(true, pm, paymentsRepoSvc, http);
    }

    const processorConfigId = data.ProcessorConfigId;
    const makeDefault = data.MakeDefault;
    const clientSecret = data.ClientSecret;
    const nameOnCard = data.NameOnCard;
    const billingEmail = data.BillingEmail;
    const nickname = data.Nickname;

    return from(elements.submit())
      .pipe(mergeMap(r => {
        const details = {
          elements: elements,
          redirect: 'if_required',
          confirmParams: { /* return_url: returnUrl */
            payment_method_data: {
              billing_details: {
                address: { postal_code: data.PaymentMethod.BillingPostalCode }
              }
            },
           },
          // payment_method_data: {
          //   billing_details: {
          //     address: { postal_code: data.PaymentMethod.BillingPostalCode }
          //   }
          // },
          // billing_details: {
          //   address: { postal_code: data.PaymentMethod.BillingPostalCode  }
          // }
        };
        return from(stripe.confirmSetup(details));
      }), catchError(err => {
        stripeDiagnosticsService.logError('Stripe confirmSetup threw during student purchase payment verification', err, {
          component: 'StudentPurchaseCourseComponent',
          clientSecret,
          processorConfigId
        });
        return of({ error: err });
      }),
        mergeMap(r => {
          const error = (r as any).error;
          const setupIntent = (r as any).setupIntent;
          if (error) return of({ error });

          const url = `${this.paymentsApi}/retrieve-card-details/${setupIntent.payment_method}`;
          return http.get(url)
            .pipe(mergeMap(resp => {
              const pm: PaymentMethodEntity = error != undefined ? null :
                {
                  _itemName: AppMetaDataItemNames.PaymentMethod,
                  ProcessorConfigId: processorConfigId,
                  PaymentId: setupIntent.payment_method,
                  IsDefault: makeDefault,
                  ClientSecret: clientSecret,
                  SetupIntentId: setupIntent.id,
                  BillingName: nameOnCard,
                  BillingEmail: billingEmail,
                  BillingPostalCode: data.PaymentMethod.BillingPostalCode,
                  IsActive: true,
                  DisplayName: (resp as any).Description
                };
              return this.makePaymentDefault(makeDefault, pm, paymentsRepoSvc, http);
            }));
        }));
  };

  private handleStripeError(context: string, error: any, updateMessage: boolean = true) {
    this.loading = false;

    if (updateMessage) {
      this.stripeErrorMessage = 'We could not load the secure payment form. Please refresh and try again. If the issue continues, contact support.';
    }

    this.stripeDiagnosticsService.logError(context, error, {
      component: 'StudentPurchaseCourseComponent',
      clientSecretLoaded: this.clientSecret != undefined,
      paymentType: this.paymentType
    });
  }

  ngOnDestroy(): void {
    for (let subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
  isTest(): boolean {
    const environments: EnvironmentConfigItem[] = (environment as any).environments;
    if (environments) {
      const environmentKey = (environment as any).environmentKey;
      return environmentKey == 'Test' || environmentKey == 'TestLocal';
    }
    return false;
  }
}

export interface CreatePaymentIntent {
  ClientSecret: string,
  ProcessorConfigId: number
}

export interface AddNewCard {
  PaymentMethodId?: number,
  ProcessorConfigId?: number,
  MakeDefault?: boolean,
  ClientSecret?: string,
  NameOnCard?: string,
  BillingEmail?: string,
  Nickname?: string,
  PaymentMethod?: PaymentMethodEntity
}
export interface NewCardCheckResult {
  PaymentMethod?: PaymentMethodEntity,
  error?: CardValidationResult
}
export interface CardValidationResult {
  code?: string,
  message?: string,
  type?: string
}
